// Portfolio Alerts threshold crossings, shared by the Portfolio Alerts tab and
// the alert notifier so both use one definition of "crossed".

export const THRESHOLDS = [4, 8, 15];
export const PORTFOLIO_ALERT_TYPE = "portfolio_threshold";

// Long market value of a strategy was below `pct` percent of net asset value
// yesterday and is at or above it now.
export const crossedThreshold = (prevLmv, currentLmv, nav, pct) =>
  (prevLmv / nav) * 100 < pct && (currentLmv / nav) * 100 >= pct;

const longValue = (position) => Math.max(0, position.market_value || 0);

// One alert per strategy and threshold crossed today, using the same rules as
// the Portfolio Alerts tab: current long market value per strategy against the
// previous day's value of the same positions, matched by symbol (first match).
export const findThresholdCrossings = (positions, previousPositions, nav) => {
  if (!Array.isArray(positions) || !Array.isArray(previousPositions) || !(nav > 0)) {
    return [];
  }

  const previousBySymbol = new Map();
  previousPositions.forEach((position) => {
    if (!previousBySymbol.has(position.SYMBOL)) {
      previousBySymbol.set(position.SYMBOL, position);
    }
  });

  const strategies = new Map();
  positions.forEach((position) => {
    const name = position.StrategyName;
    if (!strategies.has(name)) strategies.set(name, { current: 0, previous: 0 });
    const totals = strategies.get(name);
    totals.current += longValue(position);
    const previous = previousBySymbol.get(position.SYMBOL);
    totals.previous += previous ? longValue(previous) : 0;
  });

  const alerts = [];
  THRESHOLDS.forEach((pct) => {
    strategies.forEach((totals, name) => {
      if (crossedThreshold(totals.previous, totals.current, nav, pct)) {
        const strategy = name || "Undefined";
        alerts.push({
          type: PORTFOLIO_ALERT_TYPE,
          label: "Portfolio",
          key: `${PORTFOLIO_ALERT_TYPE}|${pct}|${name}`,
          text: `${strategy} crossed ${pct}% of net asset value`,
        });
      }
    });
  });
  return alerts;
};
